import {ValueObject} from '@s-ui/domain'

export default class TrackingDataValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {String} deps.event
   * @param {Object} deps.data
   * @param {Object} deps.identify
   * @param {String} deps.identify.userId
   * @param {Object} deps.identify.data
   * @param {Boolean} deps.reset
   */
  constructor({event, data, identify, reset}) {
    super({event, data, identify, reset})
  }

  /**
   * @method
   * @public
   */
  getEvent() {
    return this._event
  }
}
